<template id="warp_sim12">
    <div class="content1" style="font-size: 16px;">
      <!-- w-8ben -->
        <div style="padding-top: 2rem;max-height: 716px;overflow: auto;">
          <div style="border: 1px solid #e5e5e5;" v-if="dataAll.w8ben_expiry_flag == 0">
            <div class="content-top">W-8BEN</div>
            <div class="content-top1">
              <span style="flex: 1;">提交時間 <span style="margin-left: 6%;">{{dataAll.w8ben_result.createtime}}</span></span>
              <span style="flex: 1;">審批時間 <span style="margin-left: 6%;">{{dataAll.w8ben_result.endtime}}</span></span>
            </div>
            <div class="content-top1" style="background:#fafafa;">
              <span style="flex: 1;">剩餘期限 <span :style="dataAll.w8ben_result.statusflag == 1 ? 'color:#ed4849;margin-left: 6%;':'margin-left: 6%;'">{{dataAll.w8ben_result.statusstr}}</span></span>
              <span style="flex: 1;">簽署狀態 <span style="margin-left: 6%;">{{dataAll.w8ben_result.file_status}}</span></span>
            </div>
            <div class="content-top2">
              <div style="width:100%;line-height: 60px;" >簽署記錄 
              <!-- <span style="margin-left: 5%;">09/11/2019 14:35-31/12/2021 00:00</span> -->
              <!-- <span style="margin-left: 5%;">09/11/2019 14:35-31/12/2021 00:00</span> -->
              <span v-for='(item, index) in showHandleList' :key="index">
                <span style="margin-left: 3%;width: 41%;display: inline-block;"  :style="index == 2 || index == 4 || index == 6 ?  'margin-left: 10%;' :''">{{item}}</span>
              </span>
            </div>
              <div class="show-more"  v-if="this.toLearnList.length > 2" @click="showAll = !showAll">
			          {{word}}
			          <img
                  class="score-img"
                  :class="{ 'rotate-img': showAll }" 
                  src="../../../../image/dropDown.png" 
                  alt="logo"
                >
                </div>
            </div>
          </div>
          <div style="border: 1px solid #e5e5e5;" v-else>
            <div class="content-top">W-8BEN 
              <div style="color:red;float: right;" v-if="!dataList.w8ben_missionid">未簽署</div>
              <div style="color:3bc7a1;float: right;" v-else>已提交</div>
            </div>
          </div>
         
        </div>
      <!-- otc -->
        <div style="padding-top: 2rem;max-height: 716px;overflow: auto;">
            <div style="border: 1px solid #e5e5e5;" v-if="dataAll_otc.otc_expiry_flag == 0">
                <div class="content-top">Over-the-counter 場外交易</div>
                <div class="content-top1">
                <span style="flex: 1;">提交時間 <span style="margin-left: 6%;">{{dataAll_otc.otc_result.createtime}}</span></span>
                <span style="flex: 1;">截止時間 <span style="margin-left: 6%;">{{dataAll_otc.otc_result.endtime}}</span></span>
                </div>
                <div class="content-top1" style="background:#fafafa;">
                <span style="flex: 1;">剩餘期限 <span :style="dataAll_otc.otc_result.statusflag == 1 ? 'color:#ed4849;margin-left: 6%;':'margin-left: 6%;'">{{dataAll_otc.otc_result.statusstr}}</span></span>
                <span style="flex: 1;">簽署狀態 <span style="margin-left: 6%;">{{dataAll_otc.otc_result.file_status}}</span></span>
                </div>
                <div class="content-top2">
                <div style="width:100%;line-height: 60px;">簽署記錄 
                <!-- <span style="margin-left: 5%;">09/11/2019 14:35-31/12/2021 00:00</span> -->
                <!-- <span style="margin-left: 5%;">09/11/2019 14:35-31/12/2021 00:00</span> -->
                <span  v-for='(item, index) in showHandleList1' :key="index" >
                    <span style="margin-left: 3%;width: 41%;display: inline-block;" :style="index == 2 || index == 4 || index == 6 ?  'margin-left: 10%;' :''" >{{item}}</span>
                </span>
                </div>
                <div class="show-more"  v-if="this.toLearnList1.length > 2" @click="showAll1 = !showAll1">
                        {{word1}}
                        <img
                    class="score-img"
                    :class="{ 'rotate-img': showAll1 }" 
                    src="../../../../image/dropDown.png" 
                    alt="logo"
                    >
                    </div>
                </div>
            </div>
            <div style="border: 1px solid #e5e5e5;" v-else>
                <div class="content-top">Over-the-counter 場外交易
                  <div style="color:red;float: right;" v-if="!dataList.w8ben_missionid">未簽署</div>
                  <div style="color:3bc7a1;float: right;" v-else>已提交</div>
                </div>
            </div>
        </div>
        <!-- hkidr -->
        <div style="padding-top: 2rem;max-height: 716px;overflow: auto;">
          <div style="border: 1px solid #e5e5e5;" v-if="dataAll_hkidr.hkidr_expiry_flag == 0">
            <div class="content-top">香港投資者識別碼制度及場外證券交易匯報制度個人資料收集聲明</div>
            <div class="content-top1">
              <span style="flex: 1;">提交時間 <span style="margin-left: 6%;">{{dataAll_hkidr.hkidr_result.createtime}}</span></span>
              <span style="flex: 1;">登錄平台 
                <span style="margin-left: 6%;" v-if="dataAll_hkidr.hkidr_result.way == 1">iPhone</span>
                <span style="margin-left: 6%;" v-if="dataAll_hkidr.hkidr_result.way == 2">iPad</span>
                <span style="margin-left: 6%;" v-if="dataAll_hkidr.hkidr_result.way == 3">Android</span>
                <span style="margin-left: 6%;" v-if="dataAll_hkidr.hkidr_result.way == 4">Website</span>
                <span style="margin-left: 6%;" v-if="dataAll_hkidr.hkidr_result.way == 5">Email</span>
                <span style="margin-left: 6%;" v-if="dataAll_hkidr.hkidr_result.way == 6">Telephone</span>
                <span style="margin-left: 6%;" v-if="dataAll_hkidr.hkidr_result.way == 7">Post</span>
                <span style="margin-left: 6%;" v-if="dataAll_hkidr.hkidr_result.way == 8">System</span>
              </span>
            </div>
            <div class="content-top1" style="background:#fafafa;">
              <span style="flex: 1;">剩餘期限 <span :style="dataAll_hkidr.hkidr_result.statusflag == 1 ? 'color:#ed4849;margin-left: 6%;':'margin-left: 6%;'">{{dataAll_hkidr.hkidr_result.statusstr}}</span></span>
              <span style="flex: 1;">簽署狀態 <span style="margin-left: 6%;">{{dataAll_hkidr.hkidr_result.file_status}}</span></span>
            </div>
          </div>
          <div style="border: 1px solid #e5e5e5;" v-else>
            <div class="content-top">香港投資者識別碼制度及場外證券交易匯報制度個人資料收集聲明<div style="color:red;float: right;">未簽署</div></div>
          </div>
        </div>
        <!-- RPQ -->
        <div style="padding: 2rem 0 4rem 0;max-height: 716px;overflow: auto;">
          <div style="border: 1px solid #e5e5e5;" v-if="dataAll_rpq.status == '已簽署'">
            <div class="content-top">{{dataAll_rpq.filename}}</div>
            <div class="content-top1">
              <span style="flex: 1;">提交時間 <span style="margin-left: 3%;">{{dataAll_rpq.rating_date}}</span></span>
              <span style="flex: 1;">簽署狀態 <span style="margin-left: 3%;">{{dataAll_rpq.status}}</span></span>
            </div>
          </div>
          <div style="border: 1px solid #e5e5e5;" v-else-if="dataAll_rpq.status == '簽署成功'">
            <div class="content-top">{{dataAll_rpq.filename}}</div>
            <div class="content-top1">
              <span style="flex: 1;">提交時間 <span style="margin-left: 3%;">{{dataAll_rpq.rating_date}}</span></span>
              <span style="flex: 1;">審批時間 <span style="margin-left: 3%;">{{dataAll_rpq.rating_date}}</span></span>
            </div>
            <div class="content-top1" style="background:#fafafa;">
              <span style="flex: 1;">簽署狀態 <span style="margin-left: 3%;">{{dataAll_rpq.status}}</span></span>
              <span style="flex: 1;">評分結果 <span style="margin-left: 3%;">{{dataAll_rpq.risk_type}}</span></span>
            </div>
          </div>
          <div style="border: 1px solid #e5e5e5;" v-else>
            <div class="content-top">{{dataAll_rpq.filename}}
              <div style="color:red;float: right;" >{{dataAll_rpq.status}}</div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["items",'dataList'],
  data() {
    return {
      ishand: false,
      visible: true,
      toLearnList:[], //w-8BEN簽署記錄
      toLearnList1:[], //otc簽署記錄
      showAll:false,
      showAll1:false,
      dataAll:{},
      dataAll_otc:{},
      dataAll_hkidr:{},
      dataAll_rpq:{},
    };
  },
  mounted() {
    console.log(this.items, "彈窗");
    this.getUserFileStatusDetail()
    this.otcData()
    this.hkidrData()
    this.rpqData()
  },

	computed:{    
		showHandleList(){      
			if(this.showAll == false){  //收起状态-显示“展示”        
				var showList = [];  //定义⼀个空数组        
				if(this.toLearnList.length > 2){  //控制显⽰前三个          
					for(var i = 0;i < 2; i++){            
						showList.push(this.toLearnList[i])  //将数组的前3条存放到showList数组中        
					}        
				}else{          
					showList = this.toLearnList;  //个数足够显示，不需要再截取        
				}        
				return showList;  //返回当前数组      
			}else{  // 展开状态-显示“收起”      
				return this.toLearnList;      
			}    
		},     
		showHandleList1(){      
			if(this.showAll1 == false){  //收起状态-显示“展示”        
				var showList1 = [];  //定义⼀个空数组        
				if(this.toLearnList1.length > 2){  //控制显⽰前三个          
					for(var i = 0;i < 2; i++){            
						showList1.push(this.toLearnList1[i])  //将数组的前3条存放到showList数组中        
					}        
				}else{          
					showList1 = this.toLearnList1;  //个数足够显示，不需要再截取        
				}        
				return showList1;  //返回当前数组      
			}else{  // 展开状态-显示“收起”      
				return this.toLearnList1;      
			}    
		},    
		word(){      
			if(this.showAll == false){  //对⽂字进⾏处理        
				return '查看更多'      
			}else{       
				return '收起'      
			}    
		}, 
		word1(){      
			if(this.showAll1 == false){  //对⽂字进⾏处理        
				return '查看更多'      
			}else{       
				return '收起'      
			}    
		}  
	},
  methods: {
    handleCancel(ev) {
      this.$emit("child", 0);
    },
    getUserFileStatusDetail(ev) {
      this.$ajax({
        method: "post",
        url: this.$api.getUserFileStatusDetail,
        data: {
           username:this.items.username,
          tabname:'w8ben_result'
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll = res.data;
          if (res.data.w8ben_expiry_flag == 0) {
            this.toLearnList = res.data.w8ben_result.timeList;
          }
        } else {
        }
      });
    },

    otcData(ev) {
      this.$ajax({
        method: "post",
        url: this.$api.getUserFileStatusDetail,
        data: {
          username:this.items.username,
          tabname:'otc_result'
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll_otc = res.data;
          if (res.data.otc_expiry_flag == 0) {
            this.toLearnList1 = res.data.otc_result.timeList;
          }
        } else {
        }
      });
    },
    hkidrData(ev) {
      this.$ajax({
        method: "post",
        url: this.$api.getUserFileStatusDetail,
        data: {
           username:this.items.username,
          tabname:'hkidr_result'

        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll_hkidr = res.data;
        } else {
        }
      });
    },
    rpqData(ev) {
      this.$ajax({
        method: "post",
        url: this.$api.getRPQInfoByUsername,
        data: {
          username:this.items.username,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll_rpq = res.data;
        } else {
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.show-more{
  text-align: center;
  padding-bottom: 15px;
}
.score-img {
  width: 16px;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(180deg);
}
.content-top{
  width: 100%;
  height: 60px;
  background:#fafafa; 
  color: #0c8b97;
  line-height: 60px;
  padding: 0 20px;
  font-weight: 600;

}
.content-top1{
  width: 100%;
  height: 60px;
  background:#ffffff; 
  color: #000000;
  line-height: 60px;
  display: flex;
  padding: 0 20px;

}
.content-top2{
  width: 100%;
  background:#ffffff; 
  color: #000000;
  // line-height: 60px;
  padding: 0 20px;

}
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content1{
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 45rem !important;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 8%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
    font-size: 0.8rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
</style>
